export const translationMixin = {
    data: function(){
        return {
            transInit: true,
            defaultLang: 'de',
            langParam: {},
            langSetManually: false
        }
    },
    computed: {
        activeLang: {
            get() {
                return this.$store.getters.getDefaultLanguage;
            },
            set(newVal) {
            }
        },
        translations: function() {
            if(this.transInit){
                this.activeLang = this.defaultLang;
                this.setLanguage(this.activeLang);
                this.transInit = false;
            }
            let storeTranslations = this.$store.getters.getTranslations;
            return storeTranslations;
        },
        langParams: function() {
            this.activeLang == 'de' ? this.langParam = {key: 1, de: 1} : this.langParam = {key: 1, en: 1};
            return this.langParam;
        },
        langString: function(){
            if(this.user.language == 'en'){
                return 'English'
            } else if (this.user.language == 'de') {
                return 'Deutsch';
            }
            return 'Deutsch'
        }
    },
    methods: {
        setLanguage: function (lang) {
            if(lang) { this.$store.dispatch('setLanguage', lang);}
            let isLogged = this.$store.getters.isLogged;
            if(isLogged) {
                this.$socket.emit('setLanguage', this.langParams);
            } else {
                this.$http.get('translation').then(res => {
                    this.$store.commit('SET_TRANSLATION', res.data);
            });
            }
        },
        translationCreate: function(formData){
            const body = JSON.stringify(formData);
            const headers = new Headers({'Content-Type': 'application/json'});
            this.$http.post('translation/translate', body, {headers: headers})
                .then(res => {
                this.lastKey = formData.key;
            formData.key = '';
            formData.en = '';
            formData.de = '';
            this.$socket.emit('translationUpdate', this.langParams);
            this.alertSuccess();
        });
        },
        translationDelete: function(formData){
            const body = JSON.stringify(formData);
            const headers = new Headers({'Content-Type': 'application/json'});
            this.$http.post('translation/delete', body, {headers: headers})
                .then(res => {
                this.lastKey = formData.key;
            this.$socket.emit('translationUpdate', this.langParams);
            this.$store.dispatch('setErrors', this.getTranslation('lbl_translation_key_deleted') + ' ' + this.lastKey);
        });
        },
        update: function(data){
            const body = JSON.stringify(data);
            const headers = new Headers({'Content-Type': 'application/json'});
            this.$http.post('translation/update', body, {headers: headers})
                .then(res => {
                this.$socket.emit('translationUpdate', this.langParams);
        });
        },
        translationGetByKey: function(key){
            this.$http.get('translation/key/'+ key).then(res => {
                return res.data.obj[0];
        });
        },
        getTranslation: function(key) {
            if (!this.translations[key]) {
                let defTrans  = this.$store.getters.getDefaultTranslations;
                this.translations[key] = (defTrans[key]) ? defTrans[key] : key;
            }
            return this.translations[key];
        }
    },
    sockets: {
        translationUpdated: function() {
            this.setLanguage();
        }
    }
};


// WEBPACK FOOTER //
// ./src/Banet/mixins/translationMixin.js